import React from 'react';
import styles from '../styles.module.css';
import SectionHead from '@/components/general/SectionHead';
import AppLink from '@/components/common/AppLink';
import MainIcons from '@/icons/main';

export default function SectionHeadMore({
  item,
  href,
  titleClass,
}: {
  item?: { title?: string; kicker?: string; all?: string };
  href?: string;
  titleClass?: string;
}) {
  return (
    <SectionHead
      type="section"
      title={item?.title}
      tag={item?.kicker}
      // titleClass={`${styles.title}`}
      titleClass={titleClass}
      titleChild={
        <AppLink href={href} className={styles.all}>
          {item?.all}
          <MainIcons.arrowIcon
            fill="var(--brand-deep)"
            className="rotate-rtl"
            width="12px"
            height="12px"
          />
        </AppLink>
      }
      wrapper={`${styles.head}`}
    />
  );
}
